module.exports = __webpack_public_path__ + "img/ic_minus.5abe7c2d.svg";